/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'addFile': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g clip-path="url(#clip0)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.56 4.354a1.5 1.5 0 01.44 1.06V14a1 1 0 01-1 1H3a1 1 0 01-1-1V1a1 1 0 011-1h5.586a1.5 1.5 0 011.06.44l3.915 3.914zM9.5 5h3.293L9 1.207V4.5a.5.5 0 00.5.5zM9 13v-2H7v-1h2V8h1v2h2v1h-2v2H9z" _fill="#0078D2"/></g><defs><clipPath id="clip0"><path pid="1" _fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs>'
  }
})
